import { gql } from "@apollo/client";

export const loginUser = gql`
  mutation ($email: String!, $password: String!) {
    loginStore(input: { username: $email, password: $password }) {
      token
      user {
        lastName
        otherNames
        email
        phone
      }
      store {
        _id
        name
        code
        slug
        tagline
        description
        banner {
          _id
          fileUrl
        }
        logo {
          _id
          fileUrl
        }
        phone
        email
      }
    }
  }
`;

export const updatePassword = gql`
  mutation ($oldPassword: String!, $password: String!) {
    updateStorePassword(
      input: { oldPassword: $oldPassword, password: $password }
    ) {
      token
    }
  }
`;

export const resetStorePassword = gql`
  mutation ($password: String!) {
    resetStorePassword(input: { password: $password }) {
      token
      user {
        email
        lastName
        otherNames
      }
    }
  }
`;

export const sendStoreCode = gql`
  mutation ($username: String!, $type: CodeType!) {
    sendStoreCode(input: { username: $username, type: $type }) {
      user {
        email
        lastName
        otherNames
        phone
      }
      store {
        _id
        name
        code
      }
      token
    }
  }
`;

export const verifyStoreCode = gql`
  mutation ($username: String!, $code: String!, $type: CodeType!) {
    verifyStoreCode(input: { username: $username, type: $type, code: $code }) {
      user {
        lastName
        otherNames
        email
        phone
      }
      store {
        _id
        name
        code
        slug
        tagline
        description
        banner {
          _id
          fileUrl
        }
        logo {
          _id
          fileUrl
        }
        phone
        email
      }
      token
    }
  }
`;

export const updateStoreInfo = gql`
  mutation (
    $storeId: ID
    $name: String
    $logoId: ID
    $bannerId: ID
    $tagline: String
    $description: String
    $email: String
    $phone: String
    $address: String
    $countries: [ID]
    $regions: [ID]
    $cities: [ID]
    $bankName: String
    $bankBranch: String
    $bankAccountName: String
    $bankAccountNumber: String
    $mobileWalletType: String
    $mobileWalletName: String
    $mobileWalletNumber: String
    $payoutMethod: PayoutMethod
    $bankAccountType: BankAccountType
  ) {
    updateStoreSelf(
      input: {
        storeId: $storeId
        name: $name
        logoId: $logoId
        bannerId: $bannerId
        tagline: $tagline
        description: $description
        email: $email
        phone: $phone
        address: $address
        regions: $regions
        countries: $countries
        cities: $cities
        payoutDetails: {
          bankName: $bankName
          bankBranch: $bankBranch
          bankAccountName: $bankAccountName
          bankAccountNumber: $bankAccountNumber
          mobileWalletType: $mobileWalletType
          mobileWalletName: $mobileWalletName
          mobileWalletNumber: $mobileWalletNumber
          payoutMethod: $payoutMethod
          bankAccountType: $bankAccountType
        }
      }
    ) {
      _id
    }
  }
`;

export const updateUserInfo = gql`
  mutation (
    $lastName: String
    $otherNames: String
    $email: String
    $phone: String
  ) {
    updateUserSelf(
      input: {
        lastName: $lastName
        otherNames: $otherNames
        email: $email
        phone: $phone
      }
    ) {
      _id
    }
  }
`;
